import { openDB } from 'idb';
import Dexie from 'dexie';

const crypto = require('crypto');
const $spk = require('schemapack');
const Blowfish = require('javascript-blowfish');
const Promise = require('es6-promise').Promise;
require('es6-promise').polyfill();
const moment = require('moment');

class myUtils {
  // eslint-disable-next-line
  static diag(message) {
    // eslint-disable-next-line
    // console.log(message);
  }
  static popWarning(commit, title, message) {
    const wm = {}; // Warning Message
    wm.show = true;
    wm.title = title;
    wm.message = message;
    commit('setModalWarn', wm);
  }
  static getDateRange(option) {
    const dateRange = {};
    dateRange.startDate = moment();
    dateRange.endDate = moment();
    if (option === '1w') { // 1 Week
      dateRange.startDate = moment().subtract(6, 'days'); // Current plus prior 6
      dateRange.endDate = moment();
    }
    if (option === '2w') { // 2 Weeks
      dateRange.startDate = moment().subtract(13, 'days'); // Current plus prior 13
      dateRange.endDate = moment();
    }
    if (option === 'cm') { // Current Month
      dateRange.startDate = moment().startOf('month');
      dateRange.endDate = moment().endOf('month');
    }
    if (option === 'r2') { // Recent 2 Months
      dateRange.startDate = moment().subtract(1, 'month').startOf('month');
      dateRange.endDate = moment().endOf('month');
    }
    if (option === 'r3') { // Recent 3 Months
      dateRange.startDate = moment().subtract(2, 'months').startOf('month');
      dateRange.endDate = moment().endOf('month');
    }
    if (option === 'pm') { // Prior Month
      dateRange.startDate = moment().subtract(1, 'month').startOf('month');
      dateRange.endDate = moment().subtract(1, 'month').endOf('month');
    }
    if (option === '2m') { // 2 Months Prior
      dateRange.startDate = moment().subtract(2, 'months').startOf('month');
      dateRange.endDate = moment().subtract(2, 'months').endOf('month');
    }
    if (option === '3m') { // 3 Months Prior
      dateRange.startDate = moment().subtract(3, 'month').startOf('month');
      dateRange.endDate = moment().subtract(3, 'month').endOf('month');
    }
    if (option === 'cy') { // Current Year
      dateRange.startDate = moment().startOf('year');
      dateRange.endDate = moment().endOf('year');
    }
    if (option === 'py') { // Prior Year
      dateRange.startDate = moment().subtract(1, 'year').startOf('year');
      dateRange.endDate = moment().subtract(1, 'year').endOf('year');
    }
    if (option === '2y') { // Two Years Ago
      dateRange.startDate = moment().subtract(2, 'years').startOf('year');
      dateRange.endDate = moment().subtract(2, 'years').endOf('year');
    }
    return dateRange;
  }
  static packSearchOptions(chkBox) {
    let pk = 0;
    if (chkBox.dft === true) { pk += 1; }
    if (chkBox.ach === true) { pk += 2; }
    if (chkBox.pos === true) { pk += 4; }
    if (chkBox.atm === true) { pk += 8; }
    if (chkBox.xfr === true) { pk += 16; }
    if (chkBox.fee === true) { pk += 32; }
    if (chkBox.pay === true) { pk += 64; }
    if (chkBox.adv === true) { pk += 128; }
    if (chkBox.oth === true) { pk += 256; }
    if (chkBox.noRestrict === true) { pk += 32768; }
    return pk;
  }
  static unpackSearchOptions(pk) {
    const chkBox = {};
    // this.diag(`utl.unpackSearchOptions - pk=${pk}`);
    /* eslint no-bitwise: [2, { allow: ["&"] }] */
    chkBox.dft = !!(pk & 1);
    chkBox.ach = !!(pk & 2);
    chkBox.pos = !!(pk & 4);
    chkBox.atm = !!(pk & 8);
    chkBox.xfr = !!(pk & 16);
    chkBox.fee = !!(pk & 32);
    chkBox.pay = !!(pk & 64);
    chkBox.adv = !!(pk & 128);
    chkBox.oth = !!(pk & 256);
    chkBox.noRestrict = !!(pk & 32768);
    return chkBox;
  }
  static customizeDollar(value) {
    const rv = {};
    rv.rangeForm = '0'; // Not defined yet
    if (value === 'at') {
      rv.rangeForm = '1';
      rv.minDollar = '-1,000,000.00';
      rv.maxDollar = '1,000,000.00';
    }
    if (value === 'od') {
      rv.rangeForm = '1';
      rv.minDollar = '0.00';
      rv.maxDollar = '1,000,000.00';
    }
    if (value === 'ow') {
      rv.rangeForm = '1';
      rv.minDollar = '-1,000,000.00';
      rv.maxDollar = '0.00';
    }
    return rv;
  }

  static restrictToChars(input, regex) {
    // this.diag(`inp="${input}"`);
    // this.diag(`regex="${regex}"`);
    const rx = new RegExp(regex, 'g');
    // this.diag(`rx="${rx}"`);
    const matches = input.match(rx);
    // this.diag(`matches="${matches}"`);
    if (matches === null) {
      return '';
    }
    let joined = matches.join('').trim(); // join and remove leading/trailing spaces
    joined = joined.replace(/\s+/g, ' '); // Remove duplicate internal spaces
    return joined;
  }
  static scrollToTop() {
    window.scrollTo(0, 0);
  }
  static scrollToBottom() {
    const fullHeight = document.documentElement.clientHeight;
    window.scrollTo(0, fullHeight);
  }
  static scrollToMiddle(fy) {
    const fullHeight = document.documentElement.clientHeight;
    let y = fy;
    if (y > fullHeight) { y = fullHeight / 2; }
    window.scrollTo(0, y);
  }

  static padZero(num, size) {
    const s = `0000000000000000${num}`;
    return s.substr(s.length - size);
  }

  static padSpaces(num, size) {
    const s = `                ${num}`;
    return s.substr(s.length - size);
  }

  static timestamp() {
    const d = new Date();
    const h = this.padZero(d.getHours(), 2);
    const m = this.padZero(d.getMinutes(), 2);
    const s = this.padZero(d.getSeconds(), 2);
    const ms = this.padZero(d.getMilliseconds(), 3);
    return `${h}:${m}:${s}.${ms}`;
  }
  static fixNL(text) {
    return text.replace(/(?:\r\n|\r|\n)/g, '<br />');
  }
  static getServerStatus(error) {
    let msg = `Server Returned Status # ${error}`;
    if (error === 101) msg = 'Unable to contact CU (101)'; // CU Offline
    if (error === 102) msg = 'Timed out waiting for reply (102)';
    if (error === 103) msg = 'Timed out waiting for reply (103)';
    if (error === 104) msg = 'Invalid User or Password';
    if (error === 105) msg = 'Password incorrect for account';
    if (error === 106) msg = 'Authentication Failed (106)';
    if (error === 112) msg = "Account locked - Click 'Unlock Account'";
    if (error === 115) msg = 'Unable to contact CU (115)'; // linkMain down
    if (error === 118) msg = 'Unable to contact CU (118)'; // Websocket failed
    if (error === 119) msg = 'Enrollment Authentication Failed - Check Birthdate/SSN/ZIP';
    if (error === 120) msg = 'Enrollment failed - Please try later';
    if (error === 211) msg = 'Invalid Pin - Please enter the Pin sent to your phone';
    if (error === 212) msg = 'HomeBank Disabled - Please contact your CreditUnion';
    if (error === 213) msg = 'Other Member Account # or "Destination PIN" is invalid';
    if (error === 220) msg = 'Failed to save Pins to your account - Please try later';
    return msg;
  }

  static pakAct(cun, acct) {
    const cuac = (parseInt(cun, 10) * 4294967296) + parseInt(acct, 10);
    const rad16 = cuac.toString(16);
    const pkAct = crypto.createHash('md5').update(rad16).digest('hex');
    // const pkAct = crypto.createHash('md5').update(rad16).digest('base64');
    // this.diag(`cun=${cun} acct=${acct} rad16=${rad16} md5=${pkAct}`);
    return pkAct;
    /*
      cun=22000 acct=1520      rad16=55f0000005f0 md5=5f698276a545ea47fd7432293e814731
      cun=22000 acct=1520      rad16=55f0000005f0 md5=X2mCdqVF6kf9dDIpPoFHMQ==
      cun=22000 acct=1520      rad16=2lu00001fg   md5=LMruiQnoSmcrHsLbZHVlLg==
      cun=22000 acct=1520      rad16=55f0000005f0 md5=5f698276a545ea47fd7432293e814731
      cun=22000 acct=123456780 rad16=55f0075bcd0c md5=e969d557b4dd92f36074fb87709a1df3
      cun=22000 acct=123456781 rad16=55f0075bcd0d md5=bc2a96a5f7c453d6cd42f4511c2cb999
      cun=22000 acct=123456782 rad16=55f0075bcd0e md5=bd03f0c2d08810caca96e768de67cdf5
      cun=22000 acct=123456783 rad16=55f0075bcd0f md5=19a35bad9b02207138f4ff2b4b98a40e
      cun=22000 acct=123456784 rad16=55f0075bcd10 md5=2a97a9314af69c741fa28407e4f7f422
    */
  }

  static getPersist(persist, key) {
    return persist[key];
  }

  static async setPersist(myCommit, state, key, value) {
    // this.diag(`setPersist: key='${key}' value='${value}'`);
    // myCommit('utlDiag', `setPersist: key='${key}' value='${value}'`);
    if (state.persist[key] !== value) {
      await this.setMyPersist(myCommit, state, key, value);
      // myCommit('utlDiag', `set ${key} => ${value}`);
    } else {
      // myCommit('utlDiag', `${key} is already set to ${value}`);
    }
  }

  static async delPersist(myCommit, key) {
    myCommit('utlDiag', `delPersist ${key}`);
    myCommit('removeKey', key);
  }

  static getAcctToken(myCommit, state, pkAct) { // Read token for this account
    const key = `at-${pkAct}`;
    return this.getPersist(state.persist, key);
  }

  static setAcctToken(myCommit, state, pkAct, value) { // Write (or add) this account
    const key = `at-${pkAct}`;
    return this.setPersist(myCommit, state, key, value);
  }

  static delAcctToken(myCommit, pkAct) { // Delete all information for this account
    const key = `at-${pkAct}`;
    return this.delPersist(myCommit, key);
  }

  static getAcctUser(myCommit, state, pkAct) { // Read token for this account
    const key = `au-${pkAct}`;
    return this.getPersist(state.persist, key);
  }

  static setAcctUser(myCommit, state, pkAct, value) { // Write (or add) this account
    const key = `au-${pkAct}`;
    return this.setPersist(myCommit, state, key, value);
  }

  static delAcctUser(myCommit, pkAct) { // Delete all information for this account
    const key = `au-${pkAct}`;
    return this.delPersist(myCommit, key);
  }

  static setAppName(myCommit, state, value) {
    return this.setPersist(myCommit, state, 'appName', value);
  }

  static getCuNameKey(cun) {
    // return `cuName-${cun}`;
    return `cu-${cun}`;
  }

  static getCuList(persist) {
    const cuList = {};
    const keys = Object.keys(persist);
    let key;
    for (let i = 0; i < keys.length; i += 1) {
      key = keys[i];
      let cun = '';
      if (key.substr(0, 3) === 'cu-') { // New Key
        cun = key.substr(3, 5);
      }
      if (key.substr(0, 7) === 'cuName-') { // Old Key
        cun = key.substr(7, 5);
      }
      if (cun > '12999') {
        cuList[cun] = {};
        cuList[cun].key = cun;
        cuList[cun].name = persist[keys[i]];
        cuList[cun].desc = `${cun} - ${persist[keys[i]]}`;
      }
    }
    return cuList;
  }

  static getSavedSearchList(persist) {
    const ssList = [];
    const keys = Object.keys(persist);
    let key;
    let cc = 0;

    // Always show default sort first on list
    ssList[cc] = {};
    ssList[cc].key = 'svs- Top'; // Space causes to Sort to top of list
    ssList[cc].desc = 'Default 21 Reverse Order';
    ssList[cc].data = {};
    ssList[cc].data.cats = 32768;
    ssList[cc].data.dateRange = 'cdr';
    ssList[cc].data.direction = 'rev';
    ssList[cc].data.dollarRange = 'at';
    ssList[cc].data.quan = '21';
    cc += 1;

    for (let i = 0; i < keys.length; i += 1) {
      key = keys[i];
      if (key.substr(0, 4) === 'svs-') {
        ssList[cc] = {};
        ssList[cc].key = key;
        ssList[cc].desc = key.substr(4);
        ssList[cc].data = JSON.parse(persist[key]);
        // this.diag(`${cc}: ${key} ${ssList[cc].data.quan}`);
        cc += 1;
      }
    }
    ssList.sort((a, b) => (this.compareSaveKey(a, b)));
    return ssList;
  }
  static compareSaveKey(a, b) {
    if (a.key.toUpperCase() > b.key.toUpperCase()) return 1;
    if (a.key.toUpperCase() < b.key.toUpperCase()) return -1;
    return (a.key.toUpperCase() - b.key.toUpperCase());
  }

  static getCuName(persist, cun) { // Read CU information
    const key = this.getCuNameKey(cun);
    return this.getPersist(persist, key);
  }

  static setCuName(myCommit, state, cun, value) { // write CU information
    if (cun < 13000) return false;
    const key = this.getCuNameKey(cun);
    myCommit('utlDiag', `setCuName: key='${key}' value='${value}'`);
    return this.setPersist(myCommit, state, key, value);
  }

  static delCuName(myCommit, cun) { // write CU information
    const key = this.getCuNameKey(cun);
    return this.delPersist(myCommit, key);
  }

  static getQuickRange(persist, quick) { // Read CU information
    const key = `Quick${quick}`;
    return this.getPersist(persist, key);
  }

  static setQuickRange(myCommit, state, quick, value) { // write CU information
    const key = `Quick${quick}`;
    myCommit('utlDiag', `setQuickRange: key='${key}' value='${value}'`);
    return this.setPersist(myCommit, state, key, value);
  }

  static async setMyPersist(myCommit, state, key, value) {
    let strResult = null;
    if (state.persist[key] !== value) {
      // myCommit('utlDiag', 'BEGIN - setMyPersist');
      localStorage.setItem(key, value);
      // myCommit('utlDiag', 'wrote to localStorage');
      const results = [];
      if (state.idbValid) {
        const idb = state.indexedDB;
        state.persist[key] = value;
        results.push(idb.set(key, value));
        strResult = await Promise.all(results);
      } else {
        myCommit('utlDiag', 'setMyPersist FAILED - indexedDB is not Available');
      }
      // myCommit('utlDiag', 'ENDED - setMyPersist');
    }
    return strResult;
  }
  /*
          const idb = state.indexedDB;
        localStorage.removeItem(key);
        delete state.persist.key;
        myCommit('storeDiag', state.persist.key);
        await idb.delete(key);
        myCommit('storeDiag', '... complete');

   */
  static checkInPersist(myCommit, state, qKey) {
    // qKey is first 8 char of a1-xxxxxxxx or a2-xxxxxxxx
    // myCommit('utlDiag', 'checkAlreadySaved start');
    const keys = Object.keys(state.persist);
    let key;
    let match;
    for (let i = 0; i < keys.length; i += 1) {
      key = keys[i];
      match = (key.substr(0, 11) === `a1-${qKey}`);
      if (match === true) {
        break;
      }
    }
    return match;
  }
  //----------------------------------------------------------
  static async removeDuplicateAcct(myCommit, state, qKey) {
    // qKey is first 8 char of a1-xxxxxxxx or a2-xxxxxxxx
    // myCommit('utlDiag', 'removeDuplicateAcct start');
    const idb = state.indexedDB;
    const results = [];
    const keys = Object.keys(state.persist);
    let key;
    let match;
    let del;
    for (let i = 0; i < keys.length; i += 1) {
      key = keys[i];
      match = (key.substr(0, 11) === `a1-${qKey}`);
      if (key.substr(0, 11) === `a2-${qKey}`) {
        match = true;
      }
      // match = false; // Temp disable remove
      if (match === true) {
        // myCommit('utlDiag', `Remove:    ${key} -> ${state.persist[key]}`);
        localStorage.removeItem(key);
        del = delete state.persist[key];
        if (del === true) {
          // myCommit('utlDiag', 'del=true');
        } else {
          // myCommit('utlDiag', 'del=false');
        }
        // myCommit('utlDiag', state.persist.key);
        results.push(idb.delete(key));
      }
    }
    // myCommit('utlDiag', 'removeDuplicateAcct complete1');
    const retVal = Promise.all(results);
    // myCommit('utlDiag', 'removeDuplicateAcct complete2');
    return retVal;
  }
  //----------------------------------------------------------
  static async openIndexedDB(myCommit, state) {
    // myCommit('utlDiag', 'BEGIN - openIndexedDB');
    state.createdDB = false;
    let dbPromise;
    try {
      dbPromise = await openDB('ptApp', 1, {
        upgrade(db) {
          db.createObjectStore('ptData');
          state.createdDB = true;
        },
      });
    } catch (err) {
      state.idbValid = false;
      myCommit('utlDiag', `openIndexedDB Failed to open/create indexedDB - Err: ${err}`);
      // myCommit('utlDiag', 'ENDED - openIndexedDB');
      return;
    }
    state.indexedDB = {
      async get(key) {
        return (await dbPromise).get('ptData', key);
      },
      async set(key, val) {
        return (await dbPromise).put('ptData', val, key);
      },
      async delete(key) {
        return (await dbPromise).delete('ptData', key);
      },
      async clear() {
        return (await dbPromise).clear('ptData');
      },
      async keys() {
        return (await dbPromise).getAllKeys('ptData');
      },
    };
    // myCommit('utlDiag', 'ENDED - openIndexedDB');
  }

  //----------------------------------------------------------
  static async migrateLs2iDB(myCommit, state) {
    // myCommit('utlDiag', 'BEGIN - migrateLs2iDB');
    // let count = 0;
    const results = [];
    let temp = '';
    if (state.idbValid) {
      const idb = state.indexedDB;
      for (let i = 0; i < localStorage.length; i += 1) {
        const lsKey = localStorage.key(i);
        const lsValue = localStorage.getItem(lsKey);
        let dbKey = lsKey;
        let migrate = false;
        if (lsKey.substr(0, 3) === 'a1-') {
          migrate = true;
        }
        if (lsKey.substr(0, 3) === 'a2-') {
          migrate = true;
        }
        if (lsKey.substr(0, 3) === 'at:') {
          migrate = true;
          temp = lsKey.substr(3, 64);
          dbKey = `at-${temp}`;
        }
        if (lsKey.substr(0, 3) === 'cu-') {
          migrate = true;
        }
        if (lsKey.substr(0, 7) === 'cuName-') {
          migrate = true;
          temp = lsKey.substr(7, 64);
          dbKey = `cu-${temp}`;
        }
        if (lsKey.substr(0, 3) === 'cun') {
          migrate = true;
        }
        if (lsKey.substr(0, 7).toLowerCase() === 'appname') { // Match AppName and appName
          migrate = true;
          dbKey = 'appName';
        }
        if (migrate === true) {
          if (idb != null) {
            // myCommit('utlDiag', `Set-idb: ${dbKey}=${lsValue}`);
            results.push(idb.set(dbKey, lsValue));
            // count += 1;
          } else {
            myCommit('utlDiag', 'idb is not valid');
          }
        }
      }
    } else {
      myCommit('utlDiag', 'migrateLs2iDB FAILED - indexedDB is not Available');
    }
    // myCommit('utlDiag', `ENDED - migrateLs2iDB - Migrated ${count} items from LS to IDB`);
    return Promise.all(results);
  }

  //----------------------------------------------------------
  // Can't figure this out - Try later - Need to figure out how to get MS EDGE working
  // https://dexie.org/docs/
  // Swap these two lines in store to test
  // // await utl.getAllDbKeys(myCommit, state);
  // await utl.readAllDbKeys(myCommit, state);
  static async getAllDbKeys(myCommit, state) {
    myCommit('utlDiag', 'BEGIN - getAllDbKeys');
    if (state.idbValid) {
      const db = new Dexie('ptApp');
      db.version(0.1).stores({
        ptData: '',
      });
      const items = await db.ptData.toCollection().count((count) => {
        myCommit('utlDiag', `items Count = ${count}`);
        if (count > 0) {
          for (let i = 0; i < count; i += 1) {
            myCommit('utlDiag', `${i} ${items.toString()}`);
          }
        }
      });
      myCommit('utlDiag', 'END - getAllDbKeys');
    }
  }

  static async readAllDbKeys(myCommit, state) {
    // myCommit('utlDiag', 'BEGIN - readAllDbKeys');
    // let count = 0;
    const results = [];
    if (state.idbValid) {
      const idb = state.indexedDB;
      results.push(idb.keys());
      try {
        const strKeys = await Promise.all(results);
        state.idbKeyArr = strKeys.toString().split(',');
      } catch (err) {
        myCommit('utlDiag', `openIndexedDB Failed to open/create indexedDB - Err: ${err}`);
        // myCommit('utlDiag', 'ENDED - openIndexedDB');
      }
      // count = state.idbKeyArr.length;
    } else {
      myCommit('utlDiag', 'readAllDbKeys FAILED - indexedDB is not Available');
    }
    // myCommit('utlDiag', `ENDED - readAllDbKeys - Count = ${count}`);
  }

  //----------------------------------------------------------
  static async loadAllIDBItems(myCommit, state) {
    // this.diag('utl.loadAllIDBItems()');
    // myCommit('utlDiag', 'BEGIN - loadAllIDBItems');
    // let count = 0;
    if (state.idbValid) {
      const idb = state.indexedDB;
      const results = [];
      for (let i = 0; i < state.idbKeyArr.length; i += 1) {
        const key = state.idbKeyArr[i];
        // eslint-disable-next-line
        results.push(`${key}::${await idb.get(key)}`);
      }
      const data = await Promise.all(results);
      for (let i = 0; i < data.length; i += 1) {
        // this.diag(`${i} ${data[i]}`);
        const myArr = data[i].toString().split('::');
        state.persist[myArr[0]] = myArr[1];
        // this.diag(`${i} ${myArr[0]}:${myArr[1]}`);
        // myCommit('utlDiag', `${i} ${data[i]}`);
      }
      // count = data.length;
    } else {
      myCommit('utlDiag', 'loadAllIDBItems FAILED - indexedDB is not Available');
    }
    const appName = `Perfect-Teller - ptApp Version${state.cliVer}`;
    if (state.persist.appName !== appName) {
      this.setPersist(myCommit, state, 'appName', appName);
      state.persist.appName = appName;
    }
    // myCommit('utlDiag', `ENDED - loadAllIDBItems - Count=${count}`);
  }

  //----------------------------------------------------------
  // indexedDB not supported in this browser - Read array from LocalStorage
  static async loadLocalStorage(myCommit, state) {
    myCommit('utlDiag', 'BEGIN - loadLocalStorage');
    myCommit('utlDiag', 'indexedDB is not Available. Using LocalStorage instead');
    if (localStorage.length > 0) {
      for (let i = 0; i < localStorage.length; i += 1) {
        const lsKey = localStorage.key(i);
        const lsValue = localStorage.getItem(lsKey);
        let dbKey = lsKey;
        if (lsKey.substr(0, 7) === 'AppName') {
          dbKey = 'appName';
        }
        state.persist[dbKey] = lsValue;
      }
    }
    myCommit('utlDiag', `ENDED - loadLocalStorage - Count=${localStorage.length}`);
  }

  //----------------------------------------------------------

  /*
  static async isStoragePersisted() {
    this.diag('isStoragePersisted()');
    return await navigator.storage && navigator.storage.persisted ?
      navigator.storage.persisted() :
      undefined;
  }

  static async persist() {
    this.diag('persist()');
    return await navigator.storage && navigator.storage.persist ?
      navigator.storage.persist() :
      undefined;
  }
  */

  static fullDateTime() {
    const d = new Date();
    const mm = this.padZero(d.getMonth() + 1, 2);
    const dd = this.padZero(d.getDate(), 2);
    const yyyy = this.padZero(d.getFullYear(), 4);
    const h = this.padZero(d.getHours(), 2);
    const m = this.padZero(d.getMinutes(), 2);
    const s = this.padZero(d.getSeconds(), 2);
    const ms = this.padZero(d.getMilliseconds(), 3);
    return `${yyyy}${mm}${dd}${h}${m}${s}.${ms}`;
  }

  static getPackedDateTime() {
    const d = new Date();
    return `${this.padZero(d.getTime(), 14)}`;
  }

  static upkDate(pkDate) {
    const msPerDay = 24 * 60 * 60 * 1000;
    const xxDate = pkDate - 25567; // Convert 01/01/1900 to 01/01/1970
    const nDate = xxDate * msPerDay;
    const dDate = new Date(nDate);
    let dd = dDate.getDate();
    let mm = dDate.getMonth() + 1;
    const yyyy = dDate.getFullYear();
    if (dd < 10) { dd = `0${dd}`; }
    if (mm < 10) { mm = `0${mm}`; }
    return `${mm}/${dd}/${yyyy}`;
  }

  static upkTime(pkTime) {
    const t = pkTime * 2;
    let hr = Math.floor(t / 3600);
    const mi = Math.floor((t - (hr * 3600)) / 60);
    let ampm = 'AM';
    if (hr === 0) {
      hr = 12;
    } else {
      if (hr > 11) {
        ampm = 'PM';
      }
      if (hr > 12) {
        hr -= 12;
      }
    }
    return `${this.padZero(hr, 2)}:${this.padZero(mi, 2)} ${ampm}`;
  }
  static upkTimeHMS(pkTime) {
    const t = pkTime * 2;
    const hr = Math.floor(t / 3600);
    const mi = Math.floor((t - (hr * 3600)) / 60);
    const se = t - (hr * 3600) - (mi * 60);
    return `${this.padZero(hr, 2)}:${this.padZero(mi, 2)}:${this.padZero(se, 2)}`;
  }

  static pakStrDate(strDate) { // [130] Added  - Called from enroll
    const myDate = new Date(strDate);
    return this.pakDate(myDate);
  }

  static pakDate(pkDate) {
    const msPerDay = 24 * 60 * 60 * 1000;
    const nDate = Math.floor((pkDate / msPerDay) + 0.0001);
    const rDate = nDate + 25568; // Convert 01/01/1970 to 01/01/1900
    // this.diag(`myUtls-pakData-pkDate: ${pkDate} ${nDate} ${rDate}`);
    return rDate;
  }

  static unpakDate(pkDate) {
    // this.diag(`utl.unpakDate(${pkDate})`);
    const strDate = this.upkDate(pkDate);
    // this.diag(`utl.unpakDate(${pkDate}) --> '${strDate}'`);
    return new Date(strDate);
  }

  static compareDesc(a, b) {
    if (a.sortDescKey > b.sortDescKey) return 1;
    if (a.sortDescKey < b.sortDescKey) return -1;
    return (a.dateSortKey - b.dateSortKey);
  }
  static compareDraft(a, b) {
    if (a.sortDraftKey > b.sortDraftKey) return 1;
    if (a.sortDraftKey < b.sortDraftKey) return -1;
    return (a.dateSortKey - b.dateSortKey);
  }

  static keyAmount(amount) {
    let ind = '+';
    let num = this.padZero(amount, 10);
    if (amount < 0) { // [155] Negative Number
      ind = '-';
      num = this.padZero(-amount, 10);
    }
    // this.diag(`${this.padSpaces(amount, 10)} -> "${ind}${num}"`);
    return `${ind}${num}`;
  }

  static fmtDollar(amount) { // [155] beginning code re-written
    let num = amount;
    if (amount < 0) { // [155] Negative Number
      const pAmount = -amount; // Convert to positive number
      if (pAmount < 100) {
        num = `-${this.padZero(pAmount, 3)}`;
      }
    } else { // [155] Positive Number
      // eslint-disable-next-line
      if (amount < 100) {
        num = this.padZero(amount, 3);
      }
    }

    const s = `          ${num}`;
    let ss = s.substr(s.length - 10);
    // 1234567890123
    // 0123456789012
    //        000
    //        0.00
    //     1000.00
    //     1,000.00
    //  1002,399.00
    ss = `${ss.substr(0, 8)}.${ss.substr(8, 2)}`;
    if (ss[4] !== ' ' && ss[4] !== '-') ss = `${ss.substr(0, 5)},${ss.substr(5, 6)}`;
    if (ss[1] !== ' ' && ss[1] !== '-') ss = `${ss.substr(0, 2)},${ss.substr(2, 10)}`;
    return ss;
  }

  static fmtDolCent(amount) {
    const amt = this.stripDollar(amount);
    const num = Math.round(parseFloat(amt) * 100);
    return this.fmtDollar(num).trim();
  }

  static dollar100(amount) {
    const amt = this.stripDollar(amount);
    const num = Math.round(parseFloat(amt) * 100);
    return num;
  }

  static stripDollar(amount) {
    const neg = (` ${amount}`).indexOf('-'); // Find '-', if it exists (next line removes it)
    let amt = amount.replace(/[^0-9.]/g, ''); // Retain only digits 0 thru 9 and '.'
    if (neg > 0) { amt = `-${amt}`; } // If '-' was found, put it on the beginning.
    return amt;
  }

  static stripCheck(amount) {
    return amount.replace(/[^0-9]/g, ''); // Retain only digits 0 thru 9
  }

  static fmtPhone(phone) {
    const fon = phone.replace(/[^0-9]/g, '');
    let num = 'invalid phone#';
    if (fon.length === 10) {
      if (fon.substr(0, 1) !== '1') { // Not valid if starts with 1
        num = `${fon.substr(0, 3)}-${fon.substr(3, 3)}-${fon.substr(6, 4)}`;
      }
    }
    if (fon.length === 11) {
      if (fon.substr(0, 1) === '1') { // [170]
        num = `${fon.substr(1, 3)}-${fon.substr(4, 3)}-${fon.substr(7, 4)}`;
      } else {
        num = fon; // [170]
      }
    }
    if (fon.length === 5) {
      num = fon; // Keep as is - ShortCode being returned from Credit Union
    }
    if (fon.length > 11) { // [170]
      num = fon; // [170]
    }
    return num;
  }

  static fmtPin(pin8) {
    const pin = pin8.replace(/[^0-9]/g, '');
    let num = 'invalid pin';
    if (pin.length === 6) { // Accept 6 digit pin
      num = pin;
    }
    // if (pin.length === 8) { // Accept 8 digit pin
    //   num = pin;
    // }
    return num;
  }


  static fmtAPR(amount) {
    let num = amount;
    if ((amount < 1000) && (amount >= 0)) num = this.padZero(num, 4);
    const s = `          ${num}`;
    let ss = s.substr(s.length - 6);
    // 1234567890123
    // 0123456789012
    //   0000
    //  0.000
    ss = `${ss.substr(0, 3)}.${ss.substr(3, 3)}`;
    return ss;
  }
  static fmtDiem(amount) {
    let num = amount;
    if ((amount < 10000) && (amount >= 0)) num = this.padZero(num, 5);
    const s = `          ${num}`;
    let ss = s.substr(s.length - 7);
    // 1234567890123
    // 0123456789012
    //    0000
    //  0.0000
    ss = `${ss.substr(0, 3)}.${ss.substr(3, 4)}`;
    return ss;
  }
  static toTitleCase(str) {
    const splitStr = str.toLowerCase().split(' ');
    for (let i = 0; i < splitStr.length; i += 1) {
      // You do not need to check if i is larger than splitStr length, as your for does that for you
      // Assign it back to the array
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substr(1).toLowerCase();
    }
    // Directly return the joined string
    return splitStr.join(' ');
  }
  static toTitleCase2(str) {
    const splitStr = str.trim().toLowerCase().split(/\u0020|\u002d/); // Split on " " or "-"
    for (let i = 0; i < splitStr.length; i += 1) {
      // You do not need to check if i is larger than splitStr length, as your for does that for you
      // Assign it back to the array
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substr(1).toLowerCase();
    }
    // Directly return the joined string
    return splitStr.join('-');
  }
  static sleep(time) {
    return new Promise(resolve => setTimeout(resolve, time));
  }
  static extractPayload(myObject) {
    let payload;
    if (typeof myObject.payload64 !== 'undefined') {
      // this.$store.commit('putDiag', `Extract payload64 - Length=${myObject.payload64.length}`);
      payload = Buffer.from(myObject.payload64, 'base64', 'binary'); // Convert to binary from base64
    } else {
      // this.$store.commit('putDiag', `Extract payload16 - Length=${myObject.payload16.length}`);
      payload = Buffer.from(myObject.payload16, 'hex', 'binary'); // Convert to binary from hex
    }
    return payload;
  }

  static encodeHash(key, data) {
    // eslint-disable-next-line
    // console.log(data);

    const plSchema = $spk.build({
      sesh: 'uint32', // 4
      page: 'uint8', // 1
      opt: 'uint8', // 1
      seed: 'uint16', // 2
    });
    const pkt = {};
    if (typeof data.sesh === 'undefined') {
      pkt.sesh = 123456789;
    } else {
      pkt.sesh = parseInt(data.sesh, 10);
    }
    if (typeof data.page === 'undefined') {
      pkt.page = 0;
    } else {
      pkt.page = parseInt(data.page, 10);
    }
    if (typeof data.opt === 'undefined') {
      pkt.opt = 0;
    } else {
      pkt.opt = parseInt(data.opt, 10);
    }

    // eslint-disable-next-line
    pkt.seed = (data.sesh & 65535); // Allow bitwise AND (&)

    // eslint-disable-next-line
    const binx = plSchema.encode(pkt); // binx = binary packet
    const b16 = binx.toString('hex');
    const bf = new Blowfish(key);
    const encrypted = bf.encrypt(b16);
    const buffer = new Buffer(encrypted, 'binary');
    const encode = buffer.toString('hex');
    return encode;
  }

  static decodeHash(myCommit, state, key, encodex) {
    let data = {};
    data.sesh = 123456789;
    data.page = 0;
    data.opt = 0;
    data.seed = 0;
    if (typeof encodex === 'undefined') {
      // This is normal at Sign-In screen - Don't report as error
      return data;
    }

    let encode = encodex;
    if (encodex.substr(0, 1) === '#') { // remove # from beginning of line
      encode = encodex.substr(1);
    }

    if (encode.length === 0) { // only # on url - ignore error - return page 0
      return data;
    }

    if (encode.length !== 32) { // HexLengthFailed
      myCommit('utlDiag', `ErrHLF=${encode.length}`);
      return data;
    }

    const plSchema = $spk.build({
      sesh: 'uint32', // 4
      page: 'uint8', // 1
      opt: 'uint8', // 1
      seed: 'uint16', // 2
    });

    if (this.isHex32(myCommit, state, encode)) {
      const buffer = Buffer.from(encode, 'hex', 'binary');
      const encrypted = buffer.toString('binary');
      const bf = new Blowfish(key);
      const b16 = bf.decrypt(encrypted);
      let binx;
      try {
        binx = Buffer.from(b16, 'hex', 'binary');
      } catch (e) {
        myCommit('utlDiag', `Invalid encode string: '${encode}'`);
        return data;
      }
      data = plSchema.decode(binx);
      // eslint-disable-next-line
      let seed = (data.sesh & 65535); // Allow bitwise AND (&)
      if (data.seed !== seed) {
        data.page = 0; // Seed failed - Force Signout
        myCommit('utlDiag', `ErrSF=${encode}`); // SeedFailed
      }
    } else {
      myCommit('utlDiag', `ErrHF: '${encode}'`); // HexFailed
    }
    return data;
  }

  static isHex32(myCommit, state, h) {
    let diag = false;
    if (h.length !== 32) {
      myCommit('utlDiag', `isHex32 Length Error = ${h.length}`);
      return false;
    }
    let result = true;
    const valid = ' 0123456789abcdefABCDEF';
    for (let i = 0; i < 32; i += 1) {
      if (valid.indexOf(h.substr(i, 1)) < 1) {
        if (diag === false) {
          diag = true;
          myCommit('utlDiag', `isHex32 invalid ${h} is '${h.substr(i, 1)}`);
        }
        result = false;
      }
    }
    return result;
  }

  static findActiveStatement(state) {
    if (state.statementCount > 0) {
      for (let i = 0; i < state.statementCount; i += 1) {
        if (state.statements.arr[i].isActive === true) {
          return i;
        }
      }
    }
    return false;
  }
}
export default myUtils;



// WEBPACK FOOTER //
// ./src/myUtils.js